const tools = {
	parseDate: function(timestamp, complete = true) {
		if (timestamp === null)
			return null
		const date = new Date(timestamp * 1000)
		let day = date.getDate()
		let month = date.getMonth() + 1
		let year = date.getFullYear()
		let hours = date.getHours()
		let minutes = date.getMinutes()
		let seconds = date.getSeconds()
		if (day < 10)
			day = '0' + day
		if (month < 10)
			month = '0' + month
		if (hours < 10)
			hours = '0' + hours
		if (minutes < 10)
			minutes = '0' + minutes
		if (seconds < 10)
			seconds = '0' + seconds
		if (complete === true)
			return day + "/" + month + "/" + year + " " + hours + ":" + minutes + ":" + seconds
		else
			return day + "/" + month + "/" + year
	},

	queryString: function(baseurl, params) {
		const keys = Object.keys(params)
		let url = baseurl + '?'
		let a = false
		for (let i = 0; i < keys.length; i++)
		{
			const key = keys[i]
			if (Array.isArray(params[key]))
			{
				let value = ""
				let b = false
				for (let j = 0; j < params[key].length; j++)
				{
					if (!b)
						b = true
					else
						value += ","
					value += params[key][j]
				}
				if (!a)
					a = true
				else
					url += "&"
				url += key + "=" + value
			}
			// else if (params[key])
			else
			{
				if (!a)
					a = true
				else
					url += "&"
				url += key + '=' + params[key]
			}
		}
		if (url.length > 2000)
		{
			console.log("error: query string is longer than 2000 chars, can not send request to url", baseurl)
			return null
		}
		return url
	},

	getTimestamp: function(date = null) {
		if (!date)
			return Math.floor(new Date().getTime() / 1000)
		else
			return Math.floor(date.getTime() / 1000)
	},

	clone: function(obj) {
		return JSON.parse(JSON.stringify(obj))
	},

	colorText: function(color) {
		// parse hex values to int
		const r = parseInt("0x" + color.substr(0, 2))
		const g = parseInt("0x" + color.substr(2, 2))
		const b = parseInt("0x" + color.substr(4, 2))
		// calculate contrast of color (standard grayscale algorithmic formula)
		const contrast = (Math.round(r * 299) + Math.round(g * 587) + Math.round(b * 114)) / 1000
		return (contrast >= 128) ? 'black' : 'white'
	},

	concat: function(arr1, arr2) {
		let tab = arr2.slice()
		for (let i = 0; i < arr1.length; i++)
		{
			let found = false
			for (let j = 0; j < tab.length; j++)
			{
				if (tab[j]._id === arr1[i]._id)
				{
					found = true
					break
				}
			}
			if (found === false)
				tab.push(arr1[i])
		}
		return tab
	},

	parseDateDay: function(rawValue)
	{
		let val = rawValue.replace(/\D/g, '').slice(0, 2)
		if (val.length === 0)
			return { value: val, advance: false, valid: true }
		const d1 = parseInt(val[0], 10)
		if (val.length === 1)
		{
			if (d1 === 0)
				return { value: val, advance: false, valid: false }
			if (d1 > 3)
			{
				val = '0' + val
				return { value: val, advance: true, valid: true }
			}
			return { value: val, advance: false, valid: true }
		}
		const num = parseInt(val, 10)
		if (num === 0 || num > 31)
			return { value: val, advance: false, valid: false }
		return { value: val, advance: true, valid: true }
	},

	parseDateMonth: function(rawValue)
	{
		let val = rawValue.replace(/\D/g, '').slice(0, 2)
		if (val.length === 0)
			return { value: val, advance: false, valid: true }
		const m1 = parseInt(val[0], 10)
		if (val.length === 1)
		{
			if (m1 === 0)
				return { value: val, advance: false, valid: false }
			if (m1 > 1)
			{
				val = '0' + val
				return { value: val, advance: true, valid: true }
			}
			return { value: val, advance: false, valid: true }
		}
		const num = parseInt(val, 10)
		if (num === 0 || num > 12)
			return { value: val, advance: false, valid: false }
		return { value: val, advance: true, valid: true }
	},

	// Renvoie l'entrée de traduction correspondant à `lang`, en comblant champ par
	// champ avec la 1re entrée (langue par défaut) lorsqu'un champ est vide ou absent.
	// Garantit qu'un campeur dont la langue n'est pas traduite voit la version par défaut
	// plutôt qu'une chaîne vide. `translations` peut être null/undefined.
	mergeTranslation: function(translations, lang)
	{
		const list = translations || []
		const fallback = list[0] || {}
		const primary = list.find(t => t.lang === lang)
		if (!primary)
			return fallback
		const merged = { ...fallback }
		const keys = Object.keys(primary)
		for (let i = 0; i < keys.length; i++)
		{
			const key = keys[i]
			const value = primary[key]
			if (value !== null && value !== undefined && value !== '')
				merged[key] = value
		}
		return merged
	},

	//iOS (iPhone/iPad), y compris iPadOS 13+ qui se présente comme un Mac tactile
	isIos: function(userAgent, platform, maxTouchPoints) {
		if (/iPad|iPhone|iPod/.test(userAgent))
			return true
		return (platform === 'MacIntel' && maxTouchPoints > 1) ? true : false
	},

	//app déjà lancée depuis l'écran d'accueil (PWA installée)
	isStandalone: function() {
		if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches)
			return true
		return (window.navigator.standalone === true) ? true : false
	},

	// Détermine, pour un montant donné et le payment_mode d'un service, quelle sera
	// l'étape de paiement suivante dans le tunnel commande/inscription : CB imposée
	// ("cb"), paiement sur place imposé ("onsite"), ou choix laissé au vacancier
	// ("choice"). Reflète exactement la logique de Buying.proceedFromRecap et
	// Booking.confirmBooking — à garder synchronisé si cette logique évolue.
	getServicePaymentCase: function(service, amount, hasExternalLink = false) {
		if (amount <= 0 || hasExternalLink)
			return 'onsite'
		const mode = (service && service.payment_mode) || null
		if (mode === 'cb_only')
			return 'cb'
		if (mode === 'cb_optional')
		{
			const minimum = Number(service.payment_minimum)
			if (!isNaN(minimum) && minimum > 0 && amount < minimum)
				return 'onsite'
			const maximum = Number(service.payment_maximum)
			if (!isNaN(maximum) && maximum > 0 && amount > maximum)
				return 'cb'
			return 'choice'
		}
		return 'onsite'
	}
}

export default tools
